import { render, staticRenderFns } from "./about_us.vue?vue&type=template&id=708152b3&scoped=true"
import script from "./about_us.vue?vue&type=script&lang=js"
export * from "./about_us.vue?vue&type=script&lang=js"
import style0 from "./about_us.vue?vue&type=style&index=0&id=708152b3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708152b3",
  null
  
)

export default component.exports